<script setup>
import { onMounted } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import TopBar from '@/components/TopBar.vue';
import BottomNav from '@/components/BottomNav.vue';
import ToastHost from '@/components/ToastHost.vue';
import CartFloat from '@/components/CartFloat.vue';
import { useCartStore, useCatalogStore } from '@/composables/stores';

const cart = useCartStore();
const catalog = useCatalogStore();
const route = useRoute();

onMounted(async () => {
  await Promise.all([catalog.loadHome().catch(() => {}), cart.refresh().catch(() => {})]);
});
</script>

<template>
  <div class="app-shell">
    <TopBar />
    <main class="app-main" :class="{ 'has-bottom-nav': route.meta.bottomNav !== false }">
      <RouterView v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </RouterView>
    </main>
    <CartFloat v-if="cart.itemCount > 0 && route.meta.hideCartFloat !== true" />
    <BottomNav v-if="route.meta.bottomNav !== false" />
    <ToastHost />
  </div>
</template>

<style scoped>
.app-shell {
  max-width: 540px;
  margin: 0 auto;
  background: var(--surface);
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 0 1px var(--line);
}
.app-main { flex: 1; padding-bottom: 24px; }
.has-bottom-nav { padding-bottom: 96px; }
.fade-enter-active, .fade-leave-active { transition: opacity var(--t) var(--ease); }
.fade-enter-from, .fade-leave-to { opacity: 0; }
@media (max-width: 600px) {
  .app-shell { max-width: 100%; box-shadow: none; }
}
</style>
